import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ExcelService} from '../../../../services/excel.service';

@Component({
  selector: 'app-report-affirmation-details-table',
  templateUrl: './report-affirmation-details-table.component.html',
  styleUrls: ['./report-affirmation-details-table.component.scss']
})
export class ReportAffirmationDetailsTableComponent implements OnInit {
  displayEnrollments: MatTableDataSource<any>;
  displayReports = [];
  resultLength: number;
  @Input() reports;
  isLoading: boolean;
  columnsWithLevel = ['id', 'childDisplayName', 'className', 'level_description', 'fatherDisplayName', 'motherDisplayName', 'enroll_date'];
  columnsNoLevel = ['id', 'childDisplayName', 'className', 'fatherDisplayName', 'motherDisplayName', 'enroll_date'];
  displayedColumns = this.columnsWithLevel;
  constructor(public toastMessagesService: ToastMessagesService,
              public excelService: ExcelService) {
    this.isLoading = false;
  }

  ngOnInit(): void {
    this.resultLength = this.reports.length;
    this.initReports();
  }

  initReports() {
    try {
      this.isLoading = true;

      let count = 1;
      for (const report of this.reports) {
        const model = {
          id: count,
          childDisplayName: `${report.studentFirstName} ${report.studentLastName}`,
          className: report.className,
          level_description: report.activity_level ? report.levelDescription : '-',
          fatherDisplayName: report.fatherFirstName ? `${report.fatherFirstName} ${report.fatherFirstName}` : '-',
          motherDisplayName:  report.motherFirstName ? `${report.motherFirstName} ${report.motherLastName}` : '-',
          enroll_date: report.enroll_date ? report.enroll_date : '-'
        };

        this.displayReports.push(model);
        count++;
      }
      this.displayEnrollments = new MatTableDataSource<any>(this.displayReports);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

    exportToExcel() {
      const columns = [
          {key: 'id', value: 'A/A'},
        {key: 'childDisplayName', value: 'Ονοματεπώνυμο παιδιου'},
        {key: 'className', value: 'Τάξη'},
        {key: 'level_description', value: 'Επίπεδο'},
        {key: 'fatherDisplayName', value: 'Ονοματεπώνυμο πατέρα'},
        {key: 'motherDisplayName', value: 'Ονοματεπώνυμο μητέρας'},
        {key: 'enroll_date', value: 'Ημερομηνία εγγραφής'}];
      this.excelService.exportAsExcelFile(this.displayReports, this.reports[0].activityDescription, columns);
    }

  exportToPDF() {

  }

  sendExcelToEmail() {

  }

  sendPDFToEmail() {

  }
}
